import "./styles.css";

import { Routes } from "react-router-dom";
import Home from "./Routes/Home";
import { Route } from "react-router-dom";
import About from "./Routes/About";
import Service from "./Routes/Service";
import Contact from "./Routes/Contact";
import SignUp from "./Routes/SignUp";

export default function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/SignUp" element={<SignUp />} />
      </Routes>
    </div>
  );
}
